export default __webpack_public_path__ + "static/media/complementary--vehicles-or-buses--g1.28a800fd.png";